import FeaturePageTemplate from "@/components/features/FeaturePageTemplate";
import { businessFeatureGroups } from "@/content/publicFeatures";

export default function FeaturesBusinesses() {
  return (
    <FeaturePageTemplate
      audience="business"
      eyebrow="ConfirmPH for rental businesses"
      title="Connect the booking, vehicle, customer, and team."
      intro="ConfirmPH helps Philippine rental businesses capture inquiries, confirm the shared record, protect the schedule, manage vehicle readiness, complete handovers, respond to incidents, and keep operational history together."
      groups={businessFeatureGroups}
      primaryCta={{ to: "/register?as=business", label: "Create free business account" }}
      secondaryCta={{ to: "/demo-business/scenarios", label: "Try the interactive demos" }}
      seoTitle="ConfirmPH Features for Rental Businesses"
      seoDescription="Explore ConfirmPH booking intake, agreements and confirmation, conflict protection, fleet operations and legal readiness, drivers and dispatch, handovers, returns, damage and settlement, rental payments and security deposits, Finance & Books, customers, staff, and public business tools."
      canonical="/features/businesses"
    />
  );
}
